import React, { useState } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";

import { SrOnly } from "shared";

import Search from "../icons/Search";
import { SearchInput, SubmitButton } from "./styles";

import { searchURLPath } from "./helpers";

const HeaderSearch = ({ placeholder, selectedSearchType }) => {
    const { q: initialQuery } = queryString.parse(location.search);

    const [query, setQuery] = useState(initialQuery);

    const handleInputChange = e => {
        setQuery(e.target.value);
    };

    const searchPath = searchURLPath({
        currentPath: window.location.pathname,
        searchType: selectedSearchType
    });

    // TODO: As a future optimization, we might want to override the form's submit
    // handler and use react-router instead of letting the HTML form sumbit and
    // cause a page reload. Once icons and photos are in the same router, that will
    // be a lot easier. If we want to do it before that, we'll need to use the HTML
    // form every time someone does an icon search on a photo page, or vice versa.

    return (
        <form action={searchPath}>
            <SearchInput
                aria-label="Search term"
                name="q"
                placeholder={placeholder}
                value={query || ""}
                onChange={handleInputChange}
            />
            <SubmitButton
                type="submit"
                aria-labelledby="search"
                disabled={!query}
            >
                <Search />
                <SrOnly id="search">submit search</SrOnly>
            </SubmitButton>
        </form>
    );
};

HeaderSearch.propTypes = {
    placeholder: PropTypes.string,
    selectedSearchType: PropTypes.string
};

export default HeaderSearch;
